
const DirectiveEntryDiagnosticEntryAwaitingClientReview = () => {
  return (
    <p className="text-warning text-right">
      Aguardando cliente analisar o diagnóstico e orçamento
    </p>
  );
}

export default DirectiveEntryDiagnosticEntryAwaitingClientReview;
